module.exports = __webpack_public_path__ + "static/media/Stations_V1.17dc14c4.png";